import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import PostalOperatorSelector from '../../../wizard/target-node-mrd-impc-selector/components/PostalOperatorSelector';
import AdminPresetMrdImpcSidebarContainer from './AdminPresetMrdImpcSidebarContainer';
import {
  getDepartureCheckedMailProcessingCenters,
  getDeparturePostalOperators,
  getExpandedDeparturePostalOperatorsMrdAdmin,
  getSelectedDeparturePostalOperators,
} from '../../../wizard/target-node-mrd-impc-selector/redux/selectors/PostalOperatorSelectors';
import {
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpandedAdmin,
  onDeSelectAllDepartureMailProcessingCenters,
  onSelectAllDepartureMailProcessingCenters,
  retrieveOutboundPostalOperatorsRequestActionCreator,
} from '../../../wizard/target-node-mrd-impc-selector/redux/actions/DeparturePostalOperatorActions';
import { saveGlobalSelectionMrdImpcRequestActionCreator, setTabButtonStatus } from '../redux/actions/AdminDashboardActions';
import SaveIMPCSelectionModal from '../../../wizard/target-node-mrd-impc-selector/components/SaveIMPCSelectionModal';
import { createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';

export class GlobalPresetsMrdImpcContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showOnlySelectedDeparturePostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedMailProcessingCenters: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    const defaultDate = moment();
    this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: 'O',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      'Admin',
      '',
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.departureCheckedMailProcessingCenters !== prevProps.departureCheckedMailProcessingCenters && this.props.departureCheckedMailProcessingCenters.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
    if (this.props.departureCheckedMailProcessingCenters.length === 0 && prevProps.departureCheckedMailProcessingCenters.length !== 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureMailProcessingCenters(this.props.departurePostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureMailProcessingCenters();
  };

  onSelectDeparturePostalOperatorOrImpc = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    // eslint-disable-next-line react/prop-types
    this.props.departureMailProcessingCenterCheckedActionCreator(selected, this.props.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpandedAdmin(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.departureCheckedMailProcessingCenters, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
    });
  };

  openSaveSelectionModal = ({ checkedMailProcessingCenters, selections }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedMailProcessingCenters: checkedMailProcessingCenters,
      saveSelectionSelections: selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedMailProcessingCenters }) => {
    this.props.saveGlobalSelectionMrdImpcRequestActionCreator(name, checkedMailProcessingCenters);
    this.closeSaveSelectionModal();
  };

  render() {
    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailProcessingCenters,
      expanded: this.props.departureExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedDeparturePostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.departurePostalOperatorsNodes,
      onSelect: this.onSelectDeparturePostalOperatorOrImpc,
      onExpand: this.onExpandDeparturePostalOperator,
      onSelectAll: this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForDeparture,
      saveSelectionButtonHidden: true,
    };
    return (
      <div>
        <div className="operator-selector-wrapper">
          {this.state.showSaveSelectionModal &&
          <SaveIMPCSelectionModal
            saveSelection={this.saveSelection}
            closeModal={this.closeSaveSelectionModal}
            checkedMailProcessingCenters={this.state.saveSelectionCheckedMailProcessingCenters}
            selections={this.state.saveSelectionSelections}
          />
          }
          <div className="operator-sidebar">
            <AdminPresetMrdImpcSidebarContainer
              operatorType={OperatorTypes.DEPARTURE}
              operators={this.props.departurePostalOperatorsNodes}
              checked={this.props.departureCheckedMailProcessingCenters}
            />
          </div>
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <PostalOperatorSelector
                  title="MRD IMPC"
                  {...departurePostalOperatorSelectorProps}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GlobalPresetsMrdImpcContainer.propTypes = {
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveGlobalSelectionMrdImpcRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpandedAdmin: PropTypes.func,
  onSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onDeSelectAllDepartureMailProcessingCenters: PropTypes.func,
  setDirections: PropTypes.func,
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsRequestActionCreator,
  saveGlobalSelectionMrdImpcRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpandedAdmin,
  onSelectAllDepartureMailProcessingCenters,
  onDeSelectAllDepartureMailProcessingCenters,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedMailProcessingCenters: getDepartureCheckedMailProcessingCenters(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperatorsMrdAdmin(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsMrdImpcContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsMrdImpcContainer);

export default (ConnectedGlobalPresetsMrdImpcContainer);
